import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import { BarListView } from 'src/sections/bar/view';

export default function BarListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Bar</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_BAR_ITEM,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <BarListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
